import { createStore } from "vuex";
import config from "./config";
import * as $api from "./api";
import { identify, setSupportIdentity } from "./analytics";
import { getSelectedTeamId, switchWorkspace } from "./workspace";

function getPaddlePrice(planId) {
  return new Promise((resolve, reject) => {
    try {
      return resolve([]);
      // window.Paddle.Product.Prices(planId, (prices) => {
      //   console.log(prices);
      //   return resolve(prices.recurring.price.gross);
      // });
    } catch (err) {
      console.error(err);
      return reject(err);
    }
  });
}

const store = createStore({
  state: {
    config,
    plans: [{}, {}, {}, {}],
    userPlan: {
      user: {},
      plan: {},
    },
    user: {
      emailVerified: false,
    }, // firebase data
    isLoading: true,
    userProfile: null,
    snackbar: {
      content: "",
      color: "",
    },
    userDomains: [],
    availableDomains: [],
    availableDomainsStrippedDown: [],
    deepLinkingDomains: [],
    isLoadingDeepLinkingDomains: false,
    deepLinkingDomainsError: null,
  },
  // note. 2022 edition is used to force new behviour for
  // registered users on 2022
  getters: {
    monthlyClicksCounter(state) {
      return state.userPlan.user.monthly_clicks_count;
    },
    totalLinksCounter(state) {
      return state.userPlan.user.links_count;
    },
    getUserName(state) {
      return state.user.displayName;
    },
    getUserEmail(state) {
      return state.user.email;
    },
    isEmailVerified(state) {
      return state.user.emailVerified;
    },
    /**
     * @returns string e.g. Sun, 03 May 2020 17:48:48 GMT
     */
    getUserSignupDate(state) {
      return state.user.metadata.creationTime;
    },
    isEmailVerified2022(state) {
      // after signup for few seconds is empty
      if (typeof state.user.metadata === "undefined") {
        return true;
      }
      const userCreationDate = new Date(state.user.metadata.creationTime);
      const now = new Date("2021-12-31T16:31:11.969Z");

      // for old accounts (< 2022) consider verified
      if (userCreationDate.getTime() < now.getTime()) {
        return true;
      }

      return state.user.emailVerified;
    },
    isAuthenticated(state) {
      if (state.userProfile === null) return false;
      return true;
    },
    canUpgrade(state) {
      return (planName) => {
        let positionOfPlan = -1;
        let positionOfUserPlan = -1;
        for (const [index, plan] of state.plans.entries()) {
          if (plan.name == planName) {
            positionOfPlan = index;
          }
          if (plan.name == state.userPlan.plan.name) {
            positionOfUserPlan = index;
          }
          if (positionOfUserPlan !== -1 && positionOfPlan !== -1) {
            break;
          }
        }
        return positionOfUserPlan < positionOfPlan;
      };
    },
    /**
     * plan of user
     */
    userPlanObject(state) {
      return state.userPlan.plan;
    },
    /** role of the signed-in person in the account shown: admin on their own account */
    role(state) {
      return state.userPlan.role || "admin";
    },
    canWrite(state, getters) {
      return getters.role !== "viewer";
    },
    isAdmin(state, getters) {
      return getters.role === "admin";
    },
    /** teams the signed-in person belongs to besides their own account, last joined first */
    teams(state) {
      return state.userPlan.teams || [];
    },
    userPlanInfo(state) {
      console.log(state.plans, JSON.stringify(state.userPlan));
      const match = state.plans.filter(
        (plan) => plan.id === state.userPlan.plan.id,
      );
      console.log(match);
      if (!match || match.length === 0) return {};
      return match[0];
    },
  },
  mutations: {
    setPlans(state, plans) {
      state.plans = plans;
    },
    setIsLoading(state, status) {
      state.isLoading = status;
    },
    setUserPlan(state, userPlan) {
      state.userPlan = userPlan;
    },
    setAvailableDomains(state, domainList) {
      const userOnlyDomains = domainList.filter((d) => d.ownerId !== null);
      state.userDomains = userOnlyDomains;
      state.availableDomains = domainList;
      state.availableDomainsStrippedDown = domainList.map((d) => d.domain);
    },
    /** Merge status from polling endpoint (GET /domains/:id/status) into the domain so UI stays in sync. */
    updateDomainStatus(state, { domainId, status }) {
      if (!status || !domainId) return;
      const statusFields = [
        "created_at",
        "ssl_verification_status",
        "ssl_validation_cname_name",
        "ssl_validation_cname_value",
        "ssl_validation_cname_status",
        "api_gateway_connection_status",
        "api_gateway_cname_target",
        "api_gateway_dns_status",
        "provisioning_error",
        "acm_certificate_status",
        "api_gateway_status",
      ];
      const merge = (domain) => {
        if (domain.domain !== domainId) return;
        statusFields.forEach((key) => {
          if (status[key] !== undefined) domain[key] = status[key];
        });
      };
      state.availableDomains.forEach(merge);
      state.userDomains.forEach(merge);
    },
    setDeepLinkingDomains(state, domainList) {
      console.log("setDeepLinkingDomains", domainList);
      state.deepLinkingDomains = domainList;
    },
    setIsLoadingDeepLinkingDomains(state, status) {
      state.isLoadingDeepLinkingDomains = status;
    },
    setDeepLinkingDomainsError(state, error) {
      state.deepLinkingDomainsError = error;
    },
    setUser(state, user) {
      // a snapshot, not the firebase user itself: reload() assigns onto that
      // object in place and auth().currentUser hands back the same instance, so
      // re-committing it is a same-reference write that vue cannot see, and the
      // verification getters above keep their stale value until a page reload
      state.user = user
        ? {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            emailVerified: user.emailVerified,
            metadata: user.metadata,
          }
        : user;
      // single choke point every auth path (boot hydration, login, signup)
      // commits through, so this is the one place identify needs to happen
      // the email and name reach the person from GET /user, out of the
      // verified token, never from the browser
      if (user && user.uid) {
        identify(user.uid);
      }
    },
    showSnackbarMessage(state, payload) {
      state.snackbar.content = payload.content;
      state.snackbar.color = payload.color;
    },
  },
  actions: {
    async getPlans({ commit }) {
      const plans = await $api.getPlans();
      for (const [index, plan] of plans.entries()) {
        if (!plan.activePaddleId) {
          continue;
        }
        console.log("getting plan", plan.activePaddleId);
        plans[index].price = await getPaddlePrice(plan.activePaddleId);
      }
      commit("setPlans", plans);
    },
    async getUserPlan({ commit, state }) {
      let userWithPlan;
      try {
        userWithPlan = await $api.getUserPlan();
      } catch (err) {
        // a signed-in firebase user with no matching db row (e.g. the initial
        // /user/signup call failed) gets 401/404 here forever; self-heal once
        // by re-running signup, then retry
        const status = err?.response?.status;
        if (status === 401 || status === 404) {
          // the self-heal is best effort. when signup fails too the account
          // really cannot be initialised, and letting its error escape raw
          // surfaced an unhandled rejection carrying the confusing secondary
          // status (a 400 from /user/signup) instead of the original cause
          try {
            await $api.initAccount();
          } catch (signupErr) {
            $api.handleApiError(signupErr);
            throw err;
          }
          userWithPlan = await $api.getUserPlan();
        } else {
          throw err;
        }
      }
      // proves who the person is to the PostHog Support widget. Kept out of
      // the store, whose state reaches the console (userPlanInfo), and from
      // there replays and Sentry: whoever holds it reads their tickets
      const supportIdentityHash = userWithPlan?.supportIdentityHash;
      if (supportIdentityHash) {
        delete userWithPlan.supportIdentityHash;
      }
      commit("setUserPlan", userWithPlan);
      if (supportIdentityHash && state.user?.uid) {
        setSupportIdentity(state.user.uid, supportIdentityHash);
      }

      // first load on this browser of someone who belongs to a team: show the team they
      // joined last (the API lists it first). A choice already made is never overridden
      const uid = state.user?.uid;
      const teams = userWithPlan?.teams || [];
      if (uid && teams.length > 0 && getSelectedTeamId(uid) === null) {
        switchWorkspace(uid, teams[0].id);
      }
    },
    async getAvailableDomains({ commit }) {
      const domainList = await $api.getDomains(true);
      commit("setAvailableDomains", domainList.result);
    },
    async getDeepLinkingDomains({ commit }) {
      commit("setIsLoadingDeepLinkingDomains", true);
      commit("setDeepLinkingDomainsError", null);
      try {
        const domainList = await $api.getDeepLinkingDomains();
        commit("setDeepLinkingDomains", domainList.result || []);
      } catch (error) {
        console.error(error);
        commit("setDeepLinkingDomainsError", error.message || error.toString());
      } finally {
        commit("setIsLoadingDeepLinkingDomains", false);
      }
    },
  },
});

export default store;
